import { render, staticRenderFns } from "./fpaPermanentReport.vue?vue&type=template&id=5d1df6c0"
import script from "./fpaPermanentReport.vue?vue&type=script&lang=js"
export * from "./fpaPermanentReport.vue?vue&type=script&lang=js"
import style0 from "./fpaPermanentReport.vue?vue&type=style&index=0&id=5d1df6c0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1df6c0')) {
      api.createRecord('5d1df6c0', component.options)
    } else {
      api.reload('5d1df6c0', component.options)
    }
    module.hot.accept("./fpaPermanentReport.vue?vue&type=template&id=5d1df6c0", function () {
      api.rerender('5d1df6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/fpaManage/fpaPermanent/fpaPermanentReport.vue"
export default component.exports